import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { ProductSetViewModel } from '~/lib/data-contract';
import { fetchProductSet } from '~/lib/fetchProductSet';
import { useFranchise } from '~/shared/utils';

export const useProductSet = () => {
    const { queryKey, franchiseAPIPath } = useFranchise();
    const router = useRouter();

    const productIds = (router.query.productIds as string) || '';

    return useQuery<ProductSetViewModel, Error>(
        ['productSet', { queryKey, productIds }],
        () => fetchProductSet({ productIds, franchiseAPIPath }),
        {
            enabled: Boolean(productIds),
            retry: false,
        }
    );
};
